import { createApp } from 'vue'

import VueFeather from 'vue-feather'
import VueApexCharts from "vue3-apexcharts"

import AOS from 'aos'
import BootstrapVueNext from 'bootstrap-vue-next'
import vClickOutside from "click-outside-vue3"
import { vMaska } from "maska"
import { CountTo } from "vue3-count-to";

// import Multiselect from "@vueform/multiselect";
// import "@vueform/multiselect/themes/default.css";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

import simplebar from "simplebar-vue";

import i18n from '@/i18n'

import App from '@/App.vue'

import 'aos/dist/aos.css'
import '@/assets/scss/config/material/app.scss'
import '@/assets/scss/mermaid.min.css'
import 'bootstrap/dist/js/bootstrap.bundle'

import '@/Libs/Resources/style.css'

import Cafeman from '@/Libs/Kernel.js'
import router from "@/Libs/Router.js"
import store from "@/Libs/Store.js"

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
})

const app = createApp(App)

app.use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .component('simplebar', simplebar)
    // .component('multiselect', Multiselect)
    .component('v-select', vSelect)
    .component('count-to', CountTo)
    .directive("maska", vMaska)
    .use(i18n)
    .use(vClickOutside)
    .use(Cafeman, { i18n })

router.isReady().then(() => {
    const currentRoute = router.currentRoute.value

    if (currentRoute.meta.permission)
        app.config.globalProperties.$ac.refresh()

    app.mount('#app')
})